import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-change-email',
  templateUrl: './confirm-change-email.component.html',
  styleUrls: ['./confirm-change-email.component.scss']
})
export class ConfirmChangeEmailComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmChangeEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    ) { }

    email: any;

  ngOnInit(): void {
    this.email = this.modalData.email
  }

}
